import FiltersHeader from "../../../../Helper/filtersHeader";
import * as Constants from '../../../../Helper/constants/constants';
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Calender, ChangePatientProfile, Image_Up, Man, Patient } from "../../../../../assets/images";
import Select from 'react-select';
import { useState } from "react";
import TagsInput from "react-tagsinput";

const AddCase = () => {
    const breadcrumData = ['Dashboard', 'Existing Patient'];
    const breadcrumItem = ['Add Case '];
    const options = [{ id: '1' }, { id: '2' }];

    const [tags, setTags] = useState([]);


    const handleChange = (tags) => {
        let arry = [...tags]
        console.log(arry, '---arry');
        console.log(tags[0], '------------------------tags');
        if (tags) {
            arry.push(tags[0])
        }
        setTags(arry)
    }

    console.log(tags, '--------------------------------tags value');
    return (
        <div className="add_case_section">
            <FiltersHeader
                header={Constants.ADD_CASE}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="case_area">
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>MR Title<span>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Diagnosing and treating"
                                    />
                                </Form.Group>
                                <div className="tag_area">
                                    <h6>Ward<span>*</span></h6>
                                    <TagsInput value={tags} inputValue={tags} onChange={handleChange} />
                                </div>
                                <Form.Group className="form-group">
                                    <Form.Label>Summary<span>*</span></Form.Label>
                                    <Form.Control
                                        as={'textarea'}
                                        type="text"
                                        placeholder="Type Here"
                                    />
                                </Form.Group>
                                <div className="dropdown_box">
                                    <h6>Ward<span>*</span></h6>
                                    <div className="dropdown_area">
                                        <Select
                                            placeholder="Radiology"
                                            options={options}
                                        />
                                    </div>
                                </div>
                            </Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Room No<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Select"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Bed No<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Select"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div className="dropdown_box">
                                <h6>Patient Type<span>*</span></h6>
                                <div className="dropdown_area">
                                    <Select
                                        placeholder="General Patient"
                                        options={options}
                                    />
                                </div>
                            </div>
                            <div className="check_box">
                                <Form.Check
                                    type="checkbox"
                                    label={'Emergency Admission'}
                                />
                            </div>
                            <div className="dropdown_box">
                                <h6>Choose Department</h6>
                                <div className="dropdown_area">
                                    <Select
                                        placeholder="Radiology"
                                        options={options}
                                    />
                                </div>
                            </div>
                            <div className="dropdown_box">
                                <h6>Consultant</h6>
                                <div className="dropdown_area">
                                    <Select
                                        placeholder="Cardiology"
                                        options={options}
                                    />
                                </div>
                            </div>
                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default AddCase;